// extracted by mini-css-extract-plugin
module.exports = {"phoneWarning":"styles_phoneWarning__1Hxsf"};